import { __extends } from "tslib";
import { Event } from './Event';
var SyncEvent = /** @class */ (function (_super) {
    __extends(SyncEvent, _super);
    function SyncEvent(type, bubbles, cancelable, changeList) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (changeList === void 0) { changeList = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        // TODO: coerce
        _this.changeList = changeList;
        return _this;
    }
    SyncEvent.classInitializer = null;
    SyncEvent.classSymbols = null;
    SyncEvent.instanceSymbols = null;
    // JS -> AS Bindings
    SyncEvent.SYNC = 'sync';
    return SyncEvent;
}(Event));
export { SyncEvent };
